import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "wyatt-availability",
  class WyattAvailability extends WYATTElement {
    constructor() {
      super();

      this.getAvailability();

      this.subscribe(
        WYATT.PubSub.events.preferredStoreChange,
        this.getAvailability.bind(this),
      );
    }

    async getAvailability() {
      if (!this.config.variantIDs) {
        this.dataset.available = false;

        return;
      }

      const availabilityResponses = await Promise.all(
        this.config.variantIDs.map((id) =>
          WYATT.storeAvailability.gettingAvailability(id),
        ),
      );

      const storeID = this.getStoreID();

      const storeAvailabilities = availabilityResponses
        .map((availabilities) =>
          availabilities.find(({ id }) => id === storeID),
        )
        .filter(Boolean);

      const available = this.isAvailableForPickup(storeAvailabilities);

      if (!available && this.config.instockStores) {
        const store = WYATT.shopify.stores.find(({ id }) => id === storeID);

        if (store && this.config.instockStores.includes(store.name)) {
          this.dataset.available = "instock-special-order";

          return;
        }
      }

      this.dataset.available = available;
    }

    getStoreID() {
      if (this.config.storeID) {
        return this.config.storeID;
      }

      const preferredStoreID = window.localStorage.getItem(
        WYATT.config.preferredStore.localStorageKey,
      );

      if (preferredStoreID) {
        return JSON.parse(preferredStoreID);
      }

      return WYATT.shopify.stores[0].id;
    }

    isAvailableForPickup(availabilities) {
      if (this.config.force) {
        return this.config.force.available;
      }

      if (!availabilities.length) {
        return false;
      }

      return availabilities.every(
        (availability) =>
          !!availability?.pickUpEnabled && !!availability?.quantityAvailable,
      );
    }
  },
);
